// extracted by mini-css-extract-plugin
export default {"passageSource":"passageSource___ETiKR"};